import {
  themeAlpine,
  themeBalham,
  themeMaterial,
  themeQuartz,
} from 'ag-grid-community'
import type React from 'react'
import { createContext, type ReactNode, useContext, useState } from 'react'

export type AGGridTheme = 'quartz' | 'alpine' | 'balham' | 'material'

interface AGGridThemeContextType {
  theme: AGGridTheme
  setTheme: (theme: AGGridTheme) => void
  getThemeClass: () => string
  getTheme: () => any
}

const AGGridThemeContext = createContext<AGGridThemeContextType | undefined>(
  undefined,
)

interface AGGridThemeProviderProps {
  children: ReactNode
  defaultTheme?: AGGridTheme
}

export const AGGridThemeProvider: React.FC<AGGridThemeProviderProps> = ({
  children,
  defaultTheme = 'material',
}) => {
  const [theme, setTheme] = useState<AGGridTheme>(defaultTheme)

  const getTheme = () => {
    switch (theme) {
      case 'quartz':
        return themeQuartz
      case 'alpine':
        return themeAlpine
      case 'balham':
        return themeBalham
      case 'material':
        return themeMaterial
      default:
        return themeQuartz
    }
  }

  const getThemeClass = () => {
    // Return empty string since we're using the new Theming API
    return ''
  }

  return (
    <AGGridThemeContext.Provider
      value={{ theme, setTheme, getThemeClass, getTheme }}
    >
      {children}
    </AGGridThemeContext.Provider>
  )
}

export const useAGGridTheme = () => {
  const context = useContext(AGGridThemeContext)
  if (context === undefined) {
    throw new Error('useAGGridTheme must be used within an AGGridThemeProvider')
  }
  return context
}
